import { useState } from 'react';
import { ReactComponent as Pipe } from '../../assets/icons/pipe.svg';
import { ReactComponent as RotateLeftIconDisabled } from '../../assets/icons/rotate_left-disabled.svg';
import { ReactComponent as RotateLeftIcon } from '../../assets/icons/rotate_left.svg';
import { ReactComponent as RotateRightIconDisabled } from '../../assets/icons/rotate_right-disabled.svg';
import { ReactComponent as RotateRightIcon } from '../../assets/icons/rotate_right.svg';
import DropdownPages from '../DropdownMenu/DropdownMenuPages.component';
import DropdownMenuZoom from '../DropdownMenu/DropdownMenuZoom.component';
import { ZoomInOut } from '../DropdownMenu/ZoomInOut.component';
import TooltipOne from '../TooltipOne/TooltipOne.component';
import { PagesNavigator } from './../../components/PagesNavigator/PagesNavigator.component';
import { CloseIcon } from './Menu/CloseIcon.component';
import CancelIcon from '@material-ui/icons/Cancel';
import { rotateAngleValue } from './Preview.types';
import { useStyles } from './Toolbar.styles';
import { fill, fillOpacity } from '../../utils/contrastSvgAttributes';
import { IconButton } from '@material-ui/core';

interface ToolbarProps {
  isOpen: boolean;
  isFullscreen: boolean;
  totalPages: number | undefined;
  currentPage: number | undefined;
  zoomFactor: number;
  zoomValues: number[];
  rotateAngle: number;
  pageActionsDisabled?: boolean;
  handleZoomChange: (event: React.ChangeEvent<{ name?: string; value: unknown | number }>) => void;
  handleZoomIn: React.MouseEventHandler<HTMLButtonElement> | undefined;
  handleZoomOut: React.MouseEventHandler<HTMLButtonElement> | undefined;
  handleRotateLeft: React.MouseEventHandler<HTMLButtonElement> | undefined;
  handleRotateRight: React.MouseEventHandler<HTMLButtonElement> | undefined;
  handleToolbarOpen: () => void;
  setCurrentPage: (page: number) => void;
  handleViewMultiplePages: (option: number) => void;
  setRotateAngle: (angle: rotateAngleValue) => void;
  isAnnotationOpenAndDocked: boolean;
}

export const Toolbar: React.FC<ToolbarProps> = (props) => {
  const [viewMultiplePages, setViewMultiplePages] = useState<boolean>(false);

  const classes = useStyles();

  const handleViewMultiple = (pages: number) => {
    if (pages === 1) {
      setViewMultiplePages(false);
    } else {
      setViewMultiplePages(true);
      props.setRotateAngle(0);
    }
    props.handleViewMultiplePages(pages);
  };

  const isRotationEnabled = !viewMultiplePages && !props.pageActionsDisabled;

  return (
    <>
      {props.isOpen && (
        <div className={classes.cardPreviewMenu} style={{ left: props.isAnnotationOpenAndDocked ? '163px' : '40px' }}>
          <PagesNavigator
            totalPages={props.totalPages}
            currentPage={props.currentPage}
            setCurrentPage={(page: number) => {
              props.setCurrentPage(page);
              props.setRotateAngle(0);
            }}
            disabled={props.pageActionsDisabled}
          />
          <Pipe className={classes.pipe} fill={fill} title="linia pionowa" />
          <ZoomInOut
            zoomFactor={props.zoomFactor}
            handleZoomIn={props.handleZoomIn}
            handleZoomOut={props.handleZoomOut}
          />
          <TooltipOne title={isRotationEnabled ? 'Obróć o 90 stopni w lewo' : ''} placement="top">
            <IconButton onClick={isRotationEnabled ? props.handleRotateLeft : undefined}>
              {isRotationEnabled ? (
                <RotateLeftIcon
                  className={classes.cardPreviewMenuIcon}
                  title="ikona obróć 90 stopni w lewo"
                  fill={fill}
                />
              ) : (
                <>
                  <CancelIcon className={classes.disabledAction} />
                  <RotateLeftIconDisabled style={{ cursor: 'not-allowed' }} fill={fill} fillOpacity={fillOpacity} />
                </>
              )}
            </IconButton>
          </TooltipOne>

          <TooltipOne title={isRotationEnabled ? 'Obróć o 90 stopni w prawo' : ''} placement="top">
            <IconButton onClick={isRotationEnabled ? props.handleRotateRight : undefined}>
              {isRotationEnabled ? (
                <RotateRightIcon title="ikona obróć 90 stopni w prawo" fill={fill} />
              ) : (
                <>
                  <CancelIcon className={classes.disabledAction} />
                  <RotateRightIconDisabled style={{ cursor: 'not-allowed' }} fill={fill} fillOpacity={fillOpacity} />
                </>
              )}
            </IconButton>
          </TooltipOne>

          <DropdownPages handleViewMultiplePages={handleViewMultiple} disabled={props.pageActionsDisabled} />

          <DropdownMenuZoom
            handleZoomChange={props.handleZoomChange}
            zoomFactor={props.zoomFactor}
            zoomValues={props.zoomValues}
          />
          <span style={{ margin: '8px 0px 0px 4px' }} onClick={props.handleToolbarOpen}>
            <CloseIcon />
          </span>
        </div>
      )}
    </>
  );
};
